import React from 'react';
import MDCTextField from './MDCTextField.js.jsx';
import MDCSelect from './MDCSelect.js.jsx';
import newLeaseModalStyles from '../../../stylesheets/management_site/newLeaseModal.module.scss';

const LeaseBasicSettings = ({
  emailTemplates = [],
  feeStructures = [],
  initialData = {},
}) => {
  const emailTemplateOptions = [
    { value: '', label: 'None' },
    ...emailTemplates.map((template) => ({
      value: template.id,
      label: template.name,
    })),
  ];

  const feeStructureOptions = [
    { value: '', label: 'None' },
    ...feeStructures.map((structure) => ({
      value: structure.id,
      label: structure.name,
    })),
  ];

  return (
    <div className={newLeaseModalStyles.newLeaseModalSection}>
      <div className={newLeaseModalStyles.sectionHeader}>
        <h3 className={newLeaseModalStyles.sectionTitle}>
          Late Fee Information
        </h3>
      </div>
      <div className={newLeaseModalStyles.sectionContent}>
        <div className="pm-flex pm-flex-3">
          <MDCSelect
            label="Overdue Payment Notice Email Template"
            name="lease[late_payment_notice_document_template_id]"
            id="lease_late_payment_notice_document_template_id"
            options={emailTemplateOptions}
            defaultValue={initialData.latePaymentNoticeDocumentTemplateId || ''}
          />
          <MDCTextField
            label="Days past due before overdue payment notice is sent"
            name="lease[days_before_late_payment_notice]"
            id="lease_days_before_late_payment_notice"
            type="text"
            size={2}
            floatAbove={true}
            defaultValue={initialData.daysBeforeLatePaymentNotice || ''}
          />
          <MDCSelect
            label="Late Fee Structure"
            name="lease[fee_structure_id]"
            id="lease_fee_structure_id"
            options={feeStructureOptions}
            defaultValue={initialData.feeStructureId || ''}
          />
        </div>
      </div>
    </div>
  );
};

export default LeaseBasicSettings;
